import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import {
  SearchGrid,
  SearchGridProps,
} from '@app/components/blocks/searchGrid/SearchGrid'
import { Variant } from '@app/components/core/tag/Tag'
import { StoredImage } from '@app/types/StoredImage'
import { AddressModel, labelAddressBuilder } from '@app/util/helpers'
import { useTranslations } from '@i18n/useLanguage'

type InitiativeSearchGridItem = {
  id: string
  to: string
  image: StoredImage | string
  title: string
  description?: string
  address: AddressModel
  phase?: string
  tagText: string
  tagVariant: Variant
  isSpotlight?: boolean
}

export type InitiativeSearchGridProps = Omit<
  SearchGridProps,
  'items' | 'gridStyle'
> & {
  items: InitiativeSearchGridItem[]
}

export const InitiativeSearchGrid = (props: InitiativeSearchGridProps) => {
  const notSpecified = useTranslations().app.common.notSpecified
  return (
    <SearchGrid
      {...props}
      items={props.items.map((i) => renderCard(i, notSpecified))}
      gridStyle={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(250px, 1fr))',
        '@media (max-width: 1200px)': {
          gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
        },
        gap: '1.5rem',
      }}
    />
  )
}

const renderCard = (item: InitiativeSearchGridItem, notSpecified: string) => {
  const { address, ...rest } = item
  return (
    <InitiativeCard
      key={item.id}
      variant={item.isSpotlight ? 'spotlight' : 'default'}
      {...rest}
      location={labelAddressBuilder(address, notSpecified) ?? notSpecified}
      description={undefined}
    />
  )
}
